import React, { useEffect, useState, useRef } from 'react';
import { VideoSectionContainer } from '../../DiaperLandingPage/styled';
import { ProductContainer, VideoCard } from './styled';
import { PriceDetailVideo } from '../../CategoryDetail/L1CategoryPage/ProductCardNew/styled';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { getSearchParams } from '../../Parenting/common';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { useRouter } from 'next/router';
import {
  DesktopHidden,
  MobileHidden,
} from '../../ProductNew/ProductDetail/styled';
import { ClothDiaperVideoSectionData } from '../../DiaperLandingPage/constants';
import { isDesktopUser } from '../../../Utils/ProductUtils';
import { fireEvent } from '../../../Utils/fireEvent';
import { getWebUserId } from '../../../Utils/helper';
import { clickCardEvent } from '../../../Utils/StoreHomePageUtils';

const ClothDiaperVideoSection = (props) => {
  const {
    store,
    element,
    isFullScreenVideoEnabled,
    setIsFullScreenVideoEnabled,
    setShowFullScreenVideo,
    setCurrentVideoIndex,
    hideFullScreen,
    forBreastFeedingWeek,
  } = props;
  const [playVideo, setplayVideo] = useState(null);
  const [cardEffect, setCardEffect] = useState();
  const router = useRouter();
  const data = ClothDiaperVideoSectionData;
  const reelData = element ? element?.items : data;

  // refs for horizontal impression tracking
  const cardsRef = useRef([]);
  const firedImpressionsRef = useRef(new Set());
  const scrollContainerRef = useRef(null);

  // DEBUG helper
  const logPrefix = '[ClothDiaperVideoSection][H-IMP]';

  const callbackFunction = (index, element) => {
    setCardEffect({ index: index, effect: 'lowOpacity' });
    clickCardEvent(element, props.element, false);
    setTimeout(() => {
      router.push(`${element?.web_url}` + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };

  const openFullScreen = (index) => {
    if (!isDesktopUser() && !hideFullScreen) {
      setShowFullScreenVideo(true);
      setIsFullScreenVideoEnabled(true);
      fireEvent({
        category: 'clicked_floating_video',
      });
      setCurrentVideoIndex(index);
    }
  };

  useEffect(() => {
    for (let i = 0; i < reelData.length; i++) {
      const video = document.getElementById('clothDiaperVideos' + i);
      if (video) {
        const options = {
          root: null, // use the viewport
          rootMargin: '0px',
          threshold: 0.8, // 50% of the video is visible
        };

        const handleIntersection = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !isFullScreenVideoEnabled) {
              video.play(); // Autoplay when in viewport
              //Number(entry.target.dataset.index);
              
              if (firedImpressionsRef.current.has(i)) return;

              firedImpressionsRef.current.add(i);
              const item = reelData[i];
              const productData = item?.productData || {};

              fireEvent({
                category: 'impression_card_in_store_home',
                card_name:
                  productData?.nickname ||
                  productData?.name ||
                  item?.title ||
                  'video_card',
                product_id: productData?.id || productData?._id || 'NA',
                user_id: getWebUserId() || 'NA',
               
                query_params:
                  typeof window !== 'undefined'
                    ? window.location.search || 'NA'
                    : 'NA',
                screen_name: 'Store',
                datetime: new Date().toISOString(),
                section_name: element?.itemType,
              });
            } else {
              video.pause(); // Pause when out of viewport
            }
          });
        };

        const observer = new IntersectionObserver(handleIntersection, options);
        observer.observe(video);
      }
    }
  }, [isFullScreenVideoEnabled, playVideo]);
  

  return (
    <VideoSectionContainer store={store} clothDiaper={true}>
      {forBreastFeedingWeek && element?.sectionBgImage ? (
        <img className="headerImage" src={element?.sectionBgImage} alt="" />
      ) : (
        <>
          <MobileHidden showAPlusPlusExp={true}>
            <h3 className={store ? 'userSpeakDesktop' : ''}>
              {element?.heading ? (
                element.heading
              ) : store ? (
                <>
                  Effective, Backed by <span>Real Reviews</span>
                </>
              ) : (
                'Trending On Instagram🔥🔥'
              )}
            </h3>
          </MobileHidden>
          <DesktopHidden>
            <h3 className={store ? 'userSpeak' : ''}>
              {element?.heading ? (
                element.heading
              ) : store ? (
                <>
                  Effective, Backed <br /> by <span>Real Reviews</span>
                </>
              ) : (
                'Trending On Instagram🔥🔥'
              )}
            </h3>
          </DesktopHidden>
        </>
      )}

      <div className="flex" ref={scrollContainerRef}>
        {reelData?.map((item, index) => {
          const productData = item?.productData;
          return (
            <div
              className="flexItem"
              key={'videoWithGif' + index}
              ref={(el) => {
                if (el) cardsRef.current[index] = el;
              }}
              data-index={index}
              style={{
                marginRight: index == reelData.length - 1 ? '10px' : '',
              }}
            >
              <AnchorCoverTag
                url={productData?.web_url}
                cardEffect={cardEffect?.index === index ? 'lowOpacity' : ''}
                callbackFunction={() => callbackFunction(index, productData)}
                index={index}
                key={'chips' + index}
              >
                <VideoCard store={store}>
                  <div className="videoOuter">
                    <video
                      id={'clothDiaperVideos' + index}
                      playsInline
                      autoPlay
                      muted={playVideo != index}
                      loop
                      onClick={() => openFullScreen(index)}
                    >
                      <source src={item.url} />
                    </video>

                    <img
                      className="productImg"
                      src={productData?.image}
                      alt=""
                    />
                  </div>

                  {!store ? (
                    <div className="bottomOverlay">
                      <div className="viewCount">
                        <img
                          src="https://images.myloapp.in/NestJsUploads/1720595560968-View-count.webp"
                          alt=""
                        />
                        {item.viewCount || item.views}
                      </div>

                      <img
                        src={
                          playVideo != index
                            ? 'https://images.myloapp.in/NestJsUploads/1720528923685-Mute.webp'
                            : 'https://images.myloapp.in/NestJsUploads/1720528923683-sound-on.webp'
                        }
                        onClick={() => {
                          if (playVideo != index) setplayVideo(index);
                          else setplayVideo(null);
                        }}
                        alt=""
                        className="sound"
                      />
                    </div>
                  ) : (
                    <ProductContainer>
                      <div className="productDetails">
                        <p className="productName">{productData?.nickname}</p>
                      </div>
                      <PriceDetailVideo store={store}>
                        <p className="sellingPrice">{productData?.price}</p>
                        {productData?.netPrice !== productData?.strikeprice ? (
                          <p className="strikePrice">
                            {productData?.strikePrice}
                          </p>
                        ) : null}
                        <p className="discount">{productData?.discount}</p>
                      </PriceDetailVideo>
                    </ProductContainer>
                  )}
                </VideoCard>
                {!store ? (
                  <p className="caption">
                    {' '}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: item.username || item.title,
                      }}
                    ></span>{' '}
                    {item.caption || item.caption}
                  </p>
                ) : null}
              </AnchorCoverTag>
            </div>
          );
        })}
      </div>
    </VideoSectionContainer>
  );
};

export default ClothDiaperVideoSection;
